import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { ContextApp } from '../../contexts/ContextApp';
import { Authorization } from '../../shared';
import { EnumsValues } from '../../enums/EnumsValues';
const DefaultRedirectPage = () => {
  const {
    user,
    functions,
    isRequiredAcceptTemrsAndConditions,
    userHasAcceptedTermsAndConditions,
  } = useContext(ContextApp);
  if (user) {
    if (
      !userHasAcceptedTermsAndConditions &&
      !Authorization.security(functions, EnumsValues.Functions.IsAdmin) &&
      isRequiredAcceptTemrsAndConditions
    )
      return <Navigate to="/app/termsandconditions" replace />;
    return <Navigate to="/app/home" replace />;
  } else {
    return <Navigate to="/login" replace />;
  }
};

export default DefaultRedirectPage;
